import { createBrowserRouter } from 'react-router';
import Home from './pages/Home';
import About from './pages/About';
import Properties from './pages/Properties';
import PropertyDetails from './pages/PropertyDetails';
import AdminLayout from './pages/admin/AdminLayout';
import AdminDashboard from './pages/admin/AdminDashboard';
import AdminProperties from './pages/admin/AdminProperties';
import AddProperty from './pages/admin/AddProperty';
import EditProperty from './pages/admin/EditProperty';
import AdminCategories from './pages/admin/AdminCategories';
import AdminAbout from './pages/admin/AdminAbout';
import AdminFacilities from './pages/admin/AdminFacilities';
import AdminNearby from './pages/admin/AdminNearby';
import AdminSettings from './pages/admin/AdminSettings';
import AdminSQLEditor from './pages/admin/AdminSQLEditor';
import NotFound from './pages/NotFound';

export const router = createBrowserRouter([
  {
    path: '/',
    Component: Home,
  },
  {
    path: '/about',
    Component: About,
  },
  {
    path: '/properties',
    Component: Properties,
  },
  {
    path: '/property/:id',
    Component: PropertyDetails,
  },
  {
    path: '/admin',
    Component: AdminLayout,
    children: [
      { index: true, Component: AdminDashboard },
      { path: 'properties/add', Component: AddProperty },
      { path: 'properties/:id/edit', Component: EditProperty },
      { path: 'properties', Component: AdminProperties },
      { path: 'categories', Component: AdminCategories },
      { path: 'about', Component: AdminAbout },
      { path: 'facilities', Component: AdminFacilities },
      { path: 'nearby', Component: AdminNearby },
      { path: 'settings', Component: AdminSettings },
      { path: 'sql-editor', Component: AdminSQLEditor },
    ],
  },
  {
    path: '*',
    Component: NotFound,
  },
]);